import { Stack, Tab } from "@mui/material";
import { styled } from "@mui/material/styles";

import { Tabs } from "../Tabs/Tabs";

type TabContent = {
  label: string;
  value: string;
  icon: React.ReactNode;
};

interface DialogTabsProps {
  tabsContent: TabContent[];
  value: string;
  onChange: (event: React.SyntheticEvent, value: string) => void;
}

const StyledTabs = styled(Tabs)(({ theme }) => ({
  width: "100%",
  "& .MuiTabs-flexContainer": {
    gap: theme.spacing(1),
  },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
  justifyContent: "flex-start",
  minHeight: theme.spacing(5),
}));

const StyledIconWrapper = styled("div")(({ theme }) => ({
  minWidth: theme.spacing(5),
}));

export const DialogTabs = (props: DialogTabsProps) => {
  const { tabsContent, value, onChange } = props;

  return (
    <StyledTabs value={value} onChange={onChange} orientation="vertical">
      {tabsContent.map((tab) => (
        <StyledTab
          key={tab.value}
          value={tab.value}
          label={
            <Stack
              direction="row"
              spacing={1.5}
              sx={{
                alignItems: "center",
              }}
            >
              <StyledIconWrapper>{tab.icon}</StyledIconWrapper>
              <span>{tab.label}</span>
            </Stack>
          }
        />
      ))}
    </StyledTabs>
  );
};
